import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  selectedRow: null,
  formData: {
    program_id: '',
    programtype_id: 1,
    program_title: '',
    program_icon: '',
    program_ns: '',
    program_dll: '',
    program_instance: '',
    program_creator: '',
    program_parameter: '',
    program_description: '',
    program_isdisabled: 0,
    program_iswebenabled: 0,
    program_issingleinstance: 0,
    program_islocaldll: 0,
    program_islocaldb: 0,
    program_isexportedtolocal: 0,
    program_createdby: '',
    program_createddate: '',
    program_modifyby: '',
    program_modifydate: '',
    rowid: '',
    log: [],
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};
const adm07programSlice = createSlice({
  name: 'adm07program',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload, log: action.payload?.log || [] };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
  },
});
export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  resetState,
  setActiveTab,
  clearModuleState,
} = adm07programSlice.actions;
export default adm07programSlice.reducer;
